<template>
  <div>
    <van-pull-refresh v-if="total > 0"
                      v-model="isLoading"
                      :immediate-check="false"
                      @refresh="onRefresh">
      <van-list v-model="isRefresh"
                :finished="finished"
                finished-text="没有更多了"
                @load="onLoad">
        <div class="list-con">
          <div v-for="item in list"
               v-bind:key="item.SchoolBusID"
               class="list"
               @click="detailView(item)">
            <div class="title">{{item.SchoolBusNum}}</div>
            <div class="center">{{item.Registration}}</div>
            <div class="status van-hairline--top">查看</div>
          </div>
        </div>
      </van-list>
    </van-pull-refresh>
    <no-data v-else
             :needBg="true"
             class="footer"></no-data>
    <school-bus-info :schoolBusID="schoolBusID"
                     :detailModel="detailModel"
                     @closeDetail="close"></school-bus-info>
  </div>
</template>
<script>
import SchoolBusInfo from "@/pages/schoolAffairs/views/saBus/SchoolBusInfo";
import NoData from '@/components/noData/Index'

export default {
  name: "schoolBusOrder",
  components: {
    SchoolBusInfo,
    NoData
  },
  data () {
    return {
      isLoading: false, //下拉刷新状态
      pageIndex: 1,
      pageSize: 15,
      isRefresh: false, // 是否加载中
      finished: false, // 加载是否完成
      list: [],
      total: 0,

      detailModel: false,
      schoolBusID: 0 //明细
    };
  },
  created () {
    this.onLoad();
  },
  mounted () { },
  methods: {
    //list
    async onLoad () {
      this.xy.loading();
      let res = await this.xyapi.get(
        `${this.$store.state.apiPath}/api/SchoolBusSel/GetPage`,
        {
          pageIndex: this.pageIndex,
          pageSize: this.pageSize
        }
      );
      this.xy.unloading();
      if (res.success) {
        this.total = res.data.totalRecords;
        let _list = res.data.data;
        this.list = [...this.list, ..._list];
        this.pageIndex++;
        this.finished =
          this.list.length >= res.data.totalRecords ? true : false;
      } else {
        this.$toast.fail(res.msg);
      }
      // 加载状态结束
      this.isRefresh = false;
    },
    onRefresh () {
      setTimeout(() => {
        this.list = [];
        this.pageIndex = 1;
        this.isLoading = false;
        this.onLoad();
      }, 500);
    },
    detailView (item) {
      this.detailModel = true;
      this.schoolBusID = item.SchoolBusID;
    },
    close () {
      this.detailModel = false;
    }
  }
};
</script>
<style lang="less" scoped>
.list-con {
  padding: 25px;
  .list {
    margin-bottom: 20px;
    background: #fff;
    box-shadow: 0px 4px 12px 0px rgba(211, 211, 211, 0.5);
    border-radius: 8px;
    padding: 25px;
    .title {
      font-size: 32px;
    }
    .center {
      font-size: 24px;
      color: #666;
      margin: 30px 0;
    }
    .status {
      font-size: 24px;
      margin-top: 15px;
      padding: 20px 0 0px;
      text-align: right;
      color: #f90;
    }
  }
}
</style>